export default "__VITE_ASSET__cde9ee34__"